export default "__VITE_ASSET__B4S89WbE__"